import axios from "axios";
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const submitFhirJson = async (resourceJson = null, title = null, apiToken = null, 
    pubStatus = "active", aboutformstateid = null, tool = null, privateresource = false) => {
    if (typeof resourceJson === "string") {
        console.log("resourceJson sent as string");
        return null;
    }
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!resourceJson || !title) {
        console.log("no resourceJson or title");
        return null;
    }
    if (!resourceJson.resourceType) {
        console.log("no resourceJson.resourceType");
        return null;
    }
    console.log("CALLING SERVER with submitfhirresource")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            "functionid": "submitfhirresource",
            "fhirEntry": JSON.stringify(resourceJson, null, 2),
            "apiToken": apiToken,
            "resourcetype": resourceJson.resourceType,
            "title": title,
            "status": pubStatus,
            "bypasswarnings": true,
            'aboutformstateid': aboutformstateid,
            'tool': tool,
            'privateresource': privateresource
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from submitfhirresource call");
    }).catch((error) => { console.log(error); });
};

const submitFhirJsonWithFli = async (resourceJson = null, title = null, fli = null, apiToken = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!resourceJson || !title) {
        console.log("no resourceJson or title");
        return null;
    }
    if (!fli) {
        console.log("no fli");
        return null;
    }
    console.log("CALLING SERVER with submitfhirresource")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            "functionid": "submitfhirresource",
            "fhirEntry": JSON.stringify(resourceJson, null, 2),
            "apiToken": apiToken,
            "resourcetype": resourceJson.resourceType,
            "title": title,
            "identitylabel": fli, //Only works if the user is admin
            "status": "active",
            "bypasswarnings": true
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from submitfhirresource call");
    }).catch((error) => { console.log(error); });
};

const submitFhirCommentJson = async (resourceId = null, title = null, apiToken = null, path, commentJson = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!resourceId) {
        console.log("no resourceId");
        return null;
    }
    if (!title) {
        console.log("no title");
        return null;
    }
    if (!commentJson) {
        console.log("no commentJson");
        return null;
    }
    console.log("CALLING SERVER with submitrtifactassessmentcomment")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'submitrtifactassessmentcomment',
            'apiToken': apiToken,
            'aboutformstateid': resourceId,
            'path': path,
            'fhirEntry': JSON.stringify(commentJson, null, 2),
            'title': title
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from submitrtifactassessmentcomment call");
    }).catch((error) => { console.log(error); });
};

const submitVotes = async (votes = null, apiToken = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!votes) {
        console.log("no votes array");
        return null;
    }
    console.log("CALLING SERVER with submitvote")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'submitvote',
            'apiToken': apiToken,
            'votes': votes
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from submitvote call");
    }).catch((error) => { console.log(error); });
};

export default submitFhirJson;
export { submitFhirJsonWithFli, submitFhirCommentJson, submitVotes };